import React, { useState } from "react";
import {
  Checkbox,
  Modal,
  ResourceItem,
  ResourceList,
  InlineStack,
  Text,
  TextField,
  Box,
  Button,
} from "@shopify/polaris";
import PropTypes from "prop-types";

// eslint-disable-next-line import/no-cycle
import { withErrorBoundary } from "lib/hoc";

const AddProductTag = (props) => {
  const { active, cms, handleChange, productTag, rowData, setActive, setProductTag, setRowData } = props;

  const [searchValue, setSearchValue] = useState("");
  const [searchList, setSearchList] = useState(productTag);

  const handleButtonDisable = () => {
    let isDisable = true;
    productTag.forEach((tag) => {
      const { isCheck = false } = tag;
      if (isCheck) {
        isDisable = false;
      }
    });
    return isDisable;
  };
  const handleSearchChange = (searchItem) => {
    setSearchValue(searchItem);
    const tagToShow = productTag.filter((item) => {
      const { tagName = "" } = item || {};
      if ((tagName && tagName.toLowerCase().includes(searchItem)) || (tagName && tagName.includes(searchItem))) {
        return true;
      }
      return false;
    });
    setSearchList([...tagToShow]);
  };

  const onSubmit = () => {
    const addRow = [...rowData];
    productTag.forEach((item) => {
      const { tagName = "", isCheck = false } = item;
      if (isCheck) {
        addRow.push({
          tag: tagName,
          vendor: "",
          type: {
            isAll: false,
            value: "",
          },
          category: {
            isAll: false,
            value: "",
          },
        });
      }
    });
    setRowData(addRow);
    setActive(!active);
  };

  const handleCheckbox = (index, checkUncheck, tag) => {
    const tagCheckbox = [...productTag];
    tagCheckbox.forEach((tagData) => {
      if (tagData.tagName === tag) {
        // eslint-disable-next-line no-param-reassign
        tagData.isCheck = checkUncheck;
      }
      return false;
    });
    setProductTag([...tagCheckbox]);
  };

  const renderItem = (item, _, index) => {
    const { tagName = "", isCheck = false } = item;
    return (
      <ResourceItem id={tagName}>
        <InlineStack blockAlign="center">
          <Checkbox key={tagName} checked={isCheck} onChange={(action) => handleCheckbox(index, action, tagName)} />
          <Text as="span">{tagName}</Text>
        </InlineStack>
      </ResourceItem>
    );
  };

  return (
    <Modal open={active} onClose={handleChange} title={cms("section.tag.modal.title")}>
      <Modal.Section>
        <Box paddingInline="300" paddingBlockEnd="100">
          <TextField
            onChange={(value) => handleSearchChange(value)}
            value={searchValue}
            placeholder="Search Product Tags"
          />
        </Box>

        <ResourceList items={searchList} renderItem={renderItem} />
      </Modal.Section>
      <Modal.Section>
        <InlineStack align="space-between">
          <Button onClick={handleChange}>{cms("common.button.cancel")}</Button>
          <Button variant="primary" onClick={onSubmit} disabled={handleButtonDisable()}>
            {cms("section.tag.button.add")}
          </Button>
        </InlineStack>
      </Modal.Section>
    </Modal>
  );
};

export default withErrorBoundary(AddProductTag);

AddProductTag.propTypes = {
  active: PropTypes.bool,
  cms: PropTypes.func,
  handleChange: PropTypes.func,
  setActive: PropTypes.func,
};

AddProductTag.defaultProps = {
  active: null,
  cms: () => {},
  handleChange: () => {},
  setActive: () => {},
};
